import styled, { css } from 'styled-components';
import {
  ItemContainer,
  ItemArea,
} from 'src/components/MeasureSidebar/MeasureExtendedSidebar/styled';

export const Container = styled(ItemContainer)`
  align-items: center;
  ${({ theme }) => css`
    padding: ${theme.utils.pxToRem(10)}rem ${theme.utils.pxToRem(20)}rem;
    height: ${theme.utils.pxToRem(40)}rem;
  `}
`;

export const Details = styled.div`
  display: flex;
  align-items: center;
`;

export const Name = styled.div`
  ${({ theme }) => css`
    ${theme.mixins.font('medium', 14)}
    margin-right: ${theme.utils.pxToRem(8)}rem;

    ${Container}:hover & {
      color: ${theme.colors.defaultActionBlue};
    }
  `}
`;

export const Area = styled(ItemArea)`
  ${({ theme }) => theme.mixins.font('book', 14)}
`;
